var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.624 22a2.75 2.75 0 002.75-2.75h-5.5A2.75 2.75 0 009.625 22zm0-19.362L8.53 2.86a5.503 5.503 0 00-4.404 5.39c0 .864-.185 3.022-.631 5.146-.22 1.054-.517 2.153-.912 3.104h14.085c-.395-.951-.69-2.048-.912-3.104-.447-2.124-.63-4.282-.63-5.145a5.503 5.503 0 00-4.405-5.39l-1.096-.223zM18.176 16.5c.307.615.662 1.102 1.073 1.375H0c.411-.273.766-.76 1.072-1.375C2.31 14.025 2.75 9.46 2.75 8.25a6.877 6.877 0 015.506-6.738 1.375 1.375 0 112.736 0A6.877 6.877 0 0116.5 8.251c0 1.21.44 5.774 1.677 8.25z"
  })));
}

export default SvgBell;